// extracted by mini-css-extract-plugin
export default {"banner":"banner01_banner__qhvpk","contenido":"banner01_contenido__fqJNl","boton":"banner01_boton__4w0uY","icono":"banner01_icono__QgswO"};